import React from "react";
import { Warehouse, Wrench } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";

interface DecisionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectWarehouse: () => void;
  onSelectInstalled: () => void;
}

export default function DecisionModal({
  open,
  onOpenChange,
  onSelectWarehouse,
  onSelectInstalled,
}: DecisionModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[540px]">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-900">Add resource</DialogTitle>
          <p className="text-sm text-gray-500 mt-1">
            Where would you like to add this resource?
          </p>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-4 mt-4">
          {/* Card 1: Warehouse */}
          <button
            onClick={onSelectWarehouse}
            className="flex flex-col items-center text-center p-6 border border-gray-200 rounded-xl hover:border-blue-500 hover:bg-blue-50/20 transition-all group outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="p-3 bg-blue-50 text-blue-600 rounded-lg group-hover:bg-blue-100 transition-colors mb-4">
              <Warehouse className="w-6 h-6" />
            </div>
            <span className="text-sm font-semibold text-gray-900 block">Add to warehouse</span>
            <span className="text-xs text-gray-500 mt-1 block max-w-[150px]">
              Resource stored in warehouse
            </span>
          </button>

          {/* Card 2: Installed */}
          <button
            onClick={onSelectInstalled}
            className="flex flex-col items-center text-center p-6 border border-gray-200 rounded-xl hover:border-blue-500 hover:bg-blue-50/20 transition-all group outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <div className="p-3 bg-green-50 text-green-600 rounded-lg group-hover:bg-green-100 transition-colors mb-4">
              <Wrench className="w-6 h-6" />
            </div>
            <span className="text-sm font-semibold text-gray-900 block">Add installed resource</span>
            <span className="text-xs text-gray-500 mt-1 block max-w-[150px]">
              Resource already installed on-site
            </span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
